export const dataPointGroupKeys = {
  base: ['dataPointGroup'],
  dataPointsInGroup: (groupID: string | undefined | null) => [
    'dataPointsInGroup',
    ...dataPointGroupKeys.base,
    groupID,
  ],
};
